import { render } from "./ReviewTeam.vue?vue&type=template&id=59d7ae8f&scoped=true"
import script from "./ReviewTeam.vue?vue&type=script&lang=js"
export * from "./ReviewTeam.vue?vue&type=script&lang=js"

import "./ReviewTeam.vue?vue&type=style&index=0&id=59d7ae8f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d7ae8f"]])

export default __exports__